{% block swag_paypal_pos_wizard_connection_disconnect %}
    <div class="swag-paypal-pos-wizard-connection-disconnect">

        {% block swag_paypal_pos_wizard_connection_disconnect_headline_content %}
            <div class="swag-paypal-pos-wizard-connection-disconnect__content">

                {% block swag_paypal_pos_wizard_connection_disconnect_icon %}
                    <div class="swag-paypal-pos-wizard-connection-disconnect__icon-wrapper">
                        <mt-icon class="swag-paypal-pos-wizard-connection-disconnect__icon"
                                 name="regular-exclamation-triangle"
                                 size="80px"
                                 color="#de294c" />
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_connection_disconnect_headline %}
                    <div class="swag-paypal-pos-wizard-connection-disconnect__headline">
                        {{ $t('swag-paypal-pos.wizard.connectionDisconnect.headline') }}
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_connection_disconnect_info %}
                    <div class="swag-paypal-pos-wizard-connection-disconnect__info">
                        {{ $t('swag-paypal-pos.wizard.connectionDisconnect.info') }}
                    </div>
                {% endblock %}

                {% block swag_paypal_pos_wizard_connection_disconnect_user %}
                    <mt-card class="swag-paypal-pos-wizard-connection-disconnect__user"
                             position-identifier="swag-paypal-pos-wizard-connection-disconnect-user"
                             :isLoading="isFetchingInformation">
                        <sw-container class="swag-paypal-pos-wizard-connection-disconnect__user-container"
                                      columns="30px auto 150px"
                                      align="center"
                                      gap="30px">

                            {% block swag_paypal_pos_wizard_connection_disconnect_user_avatar %}
                                <sw-avatar
                                    class="swag-paypal-pos-wizard-connection-disconnect__user-avatar"
                                    size="40px"
                                    :firstName="posUser.firstName"
                                    :lastName="posUser.lastName" />
                            {% endblock %}

                            {% block swag_paypal_pos_wizard_connection_disconnect_user_information %}
                                <div class="swag-paypal-pos-wizard-connection-disconnect__user-info">

                                    {% block swag_paypal_pos_wizard_connection_disconnect_user_information_real %}
                                        <div class="swag-paypal-pos-wizard-connection-disconnect__user-info-name">
                                            {{ posUser.fullName }}
                                        </div>
                                        <div class="swag-paypal-pos-wizard-connection-disconnect__user-info-mail">
                                            {{ posUser.mail }}
                                        </div>
                                    {% endblock %}
                                </div>
                            {% endblock %}
                        </sw-container>
                    </mt-card>
                {% endblock %}
            </div>
        {% endblock %}
    </div>
{% endblock %}
